import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../../firebase';
import { signInWithEmailAndPassword } from 'firebase/auth';
import signin from './SignIn.module.css';

const SignIn = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            await signInWithEmailAndPassword(auth, email, password);
            navigate('/dashboard');
        } catch (error) {
            alert(error.message);
        }
    };

    return (
        <div className={signin['signin-container']}>
            <div className={signin['signin-form']}>
                <h2>Sign In</h2>
                <form onSubmit={handleSubmit}>
                    <div className={signin['form-group']}>
                        <label>Email</label>
                        <input
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="Enter your email"
                            required
                        />
                    </div>
                    <div className={signin['form-group']}>
                        <label>Password</label>
                        <input
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="Enter your password"
                            required
                        />
                    </div>
                    <button type="submit" className={signin['signin-button']}>Sign In</button>
                </form>
            </div>

            <div className={signin['signin-footer']}>
                <a href="/" className={signin['text-link']}>Return to Home</a>
                <a href="/signup" className={signin['text-link']}>Sign Up</a>
                <a href="/forgot-password" className={signin['text-link']}>Forgot Password</a>
            </div>
        </div>
    );
};

export default SignIn;